import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/Auth0Context';

const RegisterPage: React.FC = () => {
  const { login, isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
      return;
    }

    if (isLoading) {
      return;
    }

    if (!hasRedirected.current) {
      hasRedirected.current = true;
      login().catch((error) => {
        console.error('Signup redirect error:', error);
        hasRedirected.current = false;
      });
    }
  }, [isAuthenticated, isLoading, login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-primary-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">SkyMent</h1>
        <div className="flex items-center justify-center gap-2 text-gray-600">
          <Loader2 className="h-5 w-5 animate-spin" />
          <span>Redirecting to sign up...</span>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
